import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { LocaleContext } from '../../routes'
import Button from '../../styles/button'
import theme from '../../styles/theme'
import { ErrorLabel } from '../../styles/elements'
import { ButtonIcon } from '../../styles/image'
import Loading from './Loading'

const getTheme = buttonStates => {
  const themeType = Object.keys(buttonStates).find(
    key => buttonStates[key])
  return ({ buttonType: themeType, buttonTheme: theme.button[themeType] })
}

export default ({
  text, icon, invert, inactive, className, loading, onClick, children, errorMessage, pay,
}) => {
  const locale = useContext(LocaleContext)
  const localeText = text ? locale[text.toUpperCase()] : ''

  const history = useHistory()
  const redirect = () => history.push(`/${text}`)

  const buttonThemes = getTheme({
    invert,
    inactive,
    pay,
    default: !invert && !inactive
  })

  return (
    <>
      {errorMessage &&
        <ErrorLabel>
          {errorMessage}.
        </ErrorLabel>
      }

      <Button
        buttonTheme={buttonThemes.buttonTheme}
        loading={loading ? 1 : 0}
        className={className}
        onClick={!loading && !inactive ? (onClick || redirect) : undefined}
      >
        {icon &&
          <ButtonIcon
            className={buttonThemes.buttonType}
            alt={text} src={icon}
            isBright={!invert}
          />
        }
        {localeText}
        {loading && <Loading isButton />}
        {children}
      </Button>
    </>
  )
}
